











































import Vue from "vue";
import PlayerSlot from "@/components/arma/slots/PlayerSlot.vue";
import { SlotAvailability, SlotGroupInterface } from "@/types";
import LotterySlot from "./LotterySlot.vue";

export default Vue.extend({
  components: {
    PlayerSlot,
    LotterySlot
  },
  props: {
    slotGroup: {
      required: true,
      type: Object as () => SlotGroupInterface & SlotAvailability,
    },
    eventOwnerId: {
      required: false,
      type: [Number, String],
    },
    eventHasFinished: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isLastElement<T> (index: number, array: T[]): boolean {
      return index === array.length - 1;
    },
  },
});
